
<v-form ref="form">
    <c-flip-card
        v-if   = "company"
        color  = "white--text"
        :top   = "8"
        :right = "8"
        :style = "'height:' + height + 'px'"
    >
        <template v-slot:front>
            <div class="w-100">
                <v-row class="no-frame w-100" >
                    <div class="lm-border v-flex primary w-100"
                         style="height: 30px; border-radius: 4px; padding-top: 2px"
                    >
                        <div class="pl-2 white--text">
                            Unternehmen - {{ company.id }}
                        </div>
                        <v-spacer />
                        <div class="white--text pr-3" v-if="company && company.status">
                            {{ company.status.name }}
                        </div>

                        <slot name="toolbar"></slot>
                        <v-tooltip bottom v-if="company.weburl">
                            <template v-slot:activator="{ on, attrs }">
                                <div class="pr-0" >
                                    <a
                                        v-bind="attrs"
                                        v-on="on"
                                        @click.stop="onWeb"
                                    >
                                        <v-icon size="20" class="pr-1 white--text">mdi-web</v-icon>
                                    </a>
                                </div>
                            </template>
                            <span>Web-Site des Kunden</span>
                        </v-tooltip>

                        <v-tooltip bottom v-if="showStore">
                            <template v-slot:activator="{ on, attrs }">
                                <div class="pr-6">
                                    <a
                                        v-bind="attrs"
                                        v-on="on"
                                        @click.stop="onStore"
                                    >
                                        <v-icon size="20" class="pr-1 white--text">mdi-content-save</v-icon>
                                    </a>
                                </div>
                            </template>
                            <span>Kundendaten speichern</span>
                        </v-tooltip>
                    </div>
                </v-row>
                <v-row class="no-frame w-100 mt-1" style="height: calc(100% - 30px)">
                    <div
                        class="lm-border pa-3 pt-2 pb-0 h-100"
                        style="width: calc(100% - 1px)"
                    >
                        <v-row class="no-frame">
                            <v-col class="no-frame">
                                <v-text-field
                                    label          = "Name"
                                    v-model        = "company.name"
                                    :rules         = "[rules.required, uniqueValidation]"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame">
                            <v-col class="no-frame">
                                <v-textarea
                                    class="mb-1"
                                    label          = "Zusatz"
                                    v-model        = "company.nameAdd"
                                    rows="2"
                                    no-resize
                                    hide-details
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                        </v-row>
                        <!--
                                                <v-row class="no-frame">
                                                    <v-text-field
                                                        label="Zusatz"
                                                        v-model="company.nameAdd"
                                                    />
                                                </v-row>
                        -->
                        <v-row class="no-frame">
                            <v-col class="no-frame">
                                <f-enum-select
                                    v-model = "company.country"
                                    label   = "Land"
                                    module  = "msd"
                                    type    = "countries"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame">
                            <v-col class="col-3 no-frame pr-2">
                                <v-text-field
                                    label="PLZ"
                                    v-model="company.zip"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                            <v-col class="col-9 no-frame pl-2">
                                <v-text-field
                                    label="Stadt"
                                    v-model="company.city"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame">
                            <v-text-field
                                label="Strasse"
                                v-model="company.street"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-row>

                        <slot name="roles" />
                    </div>

                </v-row>
            </div>
        </template>
        <template v-slot:back>
            <div class="w-100 h-100">
                <c-column-header
                    label="Unternehmen"
                    class="primary w-100"
                    style="font-size: 16px;"
                >
                    <template v-slot:filter>
                        <div class="white--text pr-3" v-if="company && company.status">
                            {{ company.status.name }}
                        </div>

                        <v-tooltip bottom v-if="showStore">
                            <template v-slot:activator="{ on, attrs }">
                                <div class="pr-6">
                                    <a
                                        v-bind="attrs"
                                        v-on="on"
                                        @click.stop="onStore"
                                    >
                                        <v-icon size="20" class="pr-1 white--text">mdi-content-save</v-icon>
                                    </a>
                                </div>
                            </template>
                            <span>Kundendaten speichern</span>
                        </v-tooltip>
                    </template>
                </c-column-header>
                <div
                    class="lm-border pa-3 pt-3 pb-0 mt-1"
                    style="height: calc(100% - 30px); width: calc(100% - 1px)"
                >
                    <slot name="additional" />
                    <v-row class="no-frame" v-if="showWeb">
                        <v-text-field
                            label="Web"
                            v-model="company.weburl"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                        />
                    </v-row>

                    <v-row class="no-frame mb-2" v-if="company.dtype !== 2">
                        <v-col class="no-frame col-5 pr-2">
                            <v-select
                                :items="status"
                                item-value="id"
                                item-text="name"
                                label="Status"
                                :readonly = "true"
                                v-model="company.status"
                                @change="onStatus"
                            />
                        </v-col>
                        <v-col class="no-frame col-7 pl-2">
                            <inc-manufacturer
                                v-if="company.status === 2"
                                v-model="manufacturer"
                                label="Neues Unternehmen"
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame mt-4">
                        <v-textarea
                            label="Notizen"
                            v-model="company.comment"
                            no-resize
                            :rows          = "commentRows"
                            class          = "pt-0"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                        />
                    </v-row>
                </div>
            </div>
        </template>
    </c-flip-card>
</v-form>
